export default "__VITE_ASSET__BBXrPcwp__"